module.exports = "<html>\r\n  <body>\r\n    <p>Hi</p>\r\n  </body>\r\n</html>";